
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reminders",
      function () {
        return require("private-next-pages/reminders/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reminders"])
      });
    }
  